if(!customElements.get('custom-shoppable-image')){
    class CustomShoppableImage extends HTMLElement {
        constructor() {
            super();

            this.init();
        }

        init(){
            this.hotspots = this.querySelectorAll('.shoppable-image__hotspot');
            this.hotspotIcons = this.querySelectorAll('.shoppable-image__hotspot-icon');
            this.hotspots.forEach(hotspot => {
                const icon = hotspot.querySelector('.shoppable-image__hotspot-icon');
                icon.addEventListener('click', () => {
                    var ifProductOpen = hotspot.getAttribute('data-active') === 'true';
                    hotspot.setAttribute('data-active', !ifProductOpen);
                });

                hotspot.addEventListener('keydown', (event) => {
                    if(event.key === 'Enter'){
                        hotspot.querySelector('.btn-cart').click();
                    }
                })

                document.addEventListener('click', (event) => {
                    if(!hotspot.contains(event.target)){
                        hotspot.setAttribute('data-active', false);
                    }
                });
            });
        }
    }

    customElements.define('custom-shoppable-image', CustomShoppableImage);
}